module.exports = __webpack_public_path__ + "img/jiantou.bbcfb250.png";